import { render } from "./GoodsLamp.vue?vue&type=template&id=42108f25&scoped=true"
import script from "./GoodsLamp.vue?vue&type=script&lang=js"
export * from "./GoodsLamp.vue?vue&type=script&lang=js"

import "./GoodsLamp.vue?vue&type=style&index=0&id=42108f25&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42108f25"]])

export default __exports__